<template>
    <button type="submit"
            :name="field.handle"
            v-bind="attributes"
            :disabled="instance.sending"
    >
        <!-- {{ instance.sending ? 'Sending...' : field.label }} -->
        <span v-if="instance.sending">
            <div class="loading" id="loader-1"></div>
        </span>
        <span v-else>
            {{ field.label }}
        </span>
    </button>
</template>

<script>
    import Helper from "../Helper";

    export default {
        props: {
            field: {
                type: Object,
                required: true,
            },
            instance: {
                required: true,
            }
        },
        data() {
            return {
                attributes: {
                    class: 'btn btn-primary',
                },
            }
        },
        mounted() {
            this.attributes = Helper.setupAttributes(this.attributes, this.field.inputAttributes);
        }
    }
</script>